import project1_img from '../assets/portfolio.png'
import project2_img from '../assets/grsweb.png'
import project4_img from '../assets/quizweb.png'
import project5_img from '../assets/clgweb.png'
 export const mywork_data =[
    {
        w_no:1,
        w_name:"PHP Portfolio ",
        w_img:project1_img,
        description: "A responsive portfolio website to showcase skills and projects.",
         technologies: ["HTML", "CSS", "JavaScript", "PHP", "MYSQL"]
    },
    {
        w_no: 2,
        w_name: "Grievance Reddressal System ",
        w_img: project2_img,
        description: "Grievance Reddressal Portal for Lalit Narayan Mithila University Bihar.",
        technologies: ["HTML", "CSS", "JavaScript", "Bootstrap", "PHP", "MYSQL"],
    },
    
    {
        w_no: 4,
        w_name: "Quiz Web App ",
        w_img: project4_img,
        description: "I have Developed a DashQuiz Web application . In this Web app anyone can play quizes and see the results, This web app have also dynamic functionalities.",
        technologies: ["HTML", "CSS", "JavaScript", "Bootstrap", "PHP", "MYSQL"]
        
    },
    {
        w_no: 5,
        w_name: "College Website ",
        w_img: project5_img,
        description: "I Developed my college website to show the facilities and more about my college digitally .",
        technologies: ["HTML", "CSS", "JavaScript", "Bootstrap", "PHP", "MYSQL"]
    },
     
    
]